import axios from 'axios';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { handleHttpError } from '../utils/common';
import { OnlyFansMetricsSubscribedAtVsTotalSalesDetailsDataPoint } from './useSextforceMetricsSubscribedAtVsTotalSalesDetails';

const useSextforcePublicMetricSubscribedAt = (timezone: string, metricShareLinkId: string | undefined, metricId: string | undefined) => {
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();

    // Retrieve subscriber data
    const fetchMetric = async (): Promise<{
        subscribersGraph?: OnlyFansMetricsSubscribedAtVsTotalSalesDetailsDataPoint[];
        totalEarnings?: number;
        totalChargebacks?: number;
        counters: { spendersCount?: number };
    }> => {
        const query: string = `${settingsContext.routes.sextforce.publicMetrics}${metricShareLinkId}/subscribedAt/${metricId}?timezone=${timezone}`;

        return axios
            .get(query, {
                method: 'get',
                headers: {
                    apiKey: settingsContext.apiKey,
                },
            })
            .then(response => response.data);
    };

    return useQuery(['publicMetricSubscribedAt', metricShareLinkId, metricId, timezone], () => fetchMetric(), {
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: metricShareLinkId && metricId ? true : false,
        retry: 0,
        onError: (error: any) => {
            if (error && error.response && error.response.data && error.response.data.status && error.response.data.status === 400) {
                dialog
                    .alert({
                        message: 'Link does not exist or expired',
                        title: 'Error',
                        ok: {
                            text: 'OK',
                            color: 'primary',
                            variant: 'contained',
                        },
                    })
                    .then(() => {});

                return null;
            }

            handleHttpError(error, dialog);
        },
    });
};

export default useSextforcePublicMetricSubscribedAt;
